// extracted by mini-css-extract-plugin
export default {"HomeChoosePlans":"HomeChoosePlans_HomeChoosePlans__LGxCZ","heading":"HomeChoosePlans_heading__AXxKk","tickIcon":"HomeChoosePlans_tickIcon__+Cgu9"};